import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Text,
  Divider,
  Accordion,
  accordionItemBuilder,
} from '@wix/design-system';
import { useResponsiveComponents } from '../../hooks/useResponsiveComponents';
import { useAppContext } from '../../providers/AppContextProvider';
import { useBiLogger } from '../../providers/BiLoggerProvider';
import { useUnknownChargeContext } from '../../providers/UnknownChargeProvider';
import { serializeRequestParams } from '../../utils';

import s from './Faq.scss';
import { FaqItem } from './FaqItem';

export const Faq: React.FC = () => {
  const { t } = useTranslation();
  const [Responsive] = useResponsiveComponents();
  const { chargeDetails } = useUnknownChargeContext();
  const {
    appContext: { locale },
  } = useAppContext();
  const { biLogger } = useBiLogger();
  const params = {
    nodeId: '6254QgtObtQj40ReG5w6',
    referralInfo: 'unknown-charge',
    ...(chargeDetails.invoiceNumber
      ? { _invoiceNumber: chargeDetails.invoiceNumber }
      : {}),
  };
  const queryParams = serializeRequestParams(params);
  const faqLinks = {
    2: '//users.wix.com/account-recovery/enter-website',
    3: `//www.wix.com/support-chatbot${queryParams}`,
    4: `//www.wix.com/support-chatbot${queryParams}`,
    7: 'https://support.wix.com/en/search?term=refund',
    8: {
      1: `//support.wix.com/${locale}`,
      2: `//www.wix.com/support-chatbot${queryParams}`,
    },
  };
  const faqLinkCallbacks = {
    3: () => biLogger.faqInAnswerClick('customerCare'),
    4: () => biLogger.faqInAnswerClick('customerCare'),
    7: () => biLogger.faqInAnswerClick('cancelSubscription'),
    8: { 2: () => biLogger.faqInAnswerClick('customerCare') },
  };

  const faqItems = new Array(8).fill({}).map((_v, i) =>
    accordionItemBuilder({
      initiallyOpen: i === 0,
      title: (
        <Box maxWidth="540px">
          <Text weight="bold">{t(`charge-locator.faqs.q${i + 1}`)}</Text>
        </Box>
      ),
      children: (
        <FaqItem
          faqIndex={i}
          links={faqLinks[i + 1]}
          linkCallbacks={faqLinkCallbacks[i + 1]}
        />
      ),
    }),
  );

  return (
    <Box
      margin="0 auto SP6"
      direction="vertical"
      textAlign="center"
      maxWidth="557px"
    >
      <Box className={s.faqHeading}>
        <Responsive.FaqHeading>
          {t('charge-locator.faqs.title')}
        </Responsive.FaqHeading>
      </Box>
      <Box direction="vertical" className={s.accordion}>
        <Divider />
        <Accordion size="small" skin="neutral" hideShadow items={faqItems} />
      </Box>
    </Box>
  );
};
